<!-- eslint-disable max-lines -->
<template>
    <!-- 签收/拒收/详情 弹框 -->
    <el-dialog :closeOnClickModal='closeOnClickModal' class='signDialog receiptSignSignInDialog' title="回单上传" :visible="true" :before-close="beforeClose" width="80%">
        <div class="sign-details signDialog receiptSignSignInDialog">
            <div class="signContent">
                <div class="receiveLeft">
                    <div class="upload-header" v-if="imgArr.length">
                        <div class="upload-info">
                            <span class="upload-user">{{imgArr[carouselIndex].updateUserName}}</span>&nbsp; 在 &nbsp;<span class="upload-time">{{imgArr[carouselIndex].updateTime}}</span>上传
                        </div>
                    </div>
                    <div style="height: 300px;" v-show="imgArr.length">
                        <ul id='viewers' style="display: none;">
                            <li v-for='(item, index) in imgArr' :key='index'>
                                <img :src="item.path">
                            </li>
                        </ul>
                    </div>
                    <div v-if="imgArr.length" class="currentImgIndex">{{ carouselIndex + 1 + ' / ' + imgArr.length}}</div>
                    <div v-show="!readOnly">
                        <!-- 左边图片底部 上传 删除 下载 -->
                        <div class="uploader" v-if="imgArr.length">
                            <upload-new-btn
                                ref="uploadButton"
                                multiple
                                businessKey="default"
                                bucket="c-tms"
                                contentType="application/octet-stream"
                                :needBtn="false"
                                :publicRead="1"
                                :compressImage="true"
                                :compressQuality="0.5"
                                @beforeUpload="beforeUpload"
                                @callback="uploadResponse"
                        >
                    <i class="el-icon-plus pictures"></i>
                    </upload-new-btn>
                            <i class="el-icon-delete" @click="deleteImg"></i>
                            <i class="el-icon-download" @click="downloadImg"></i>
                        </div>
                        <div class="uploader" style="height: 200px;  position: relative;" v-else>
                            <upload-new-btn
                                ref="uploadButton"
                                type="btn"
                                multiple
                                businessKey="default"
                                bucket="srm"
                                contentType="application/octet-stream"
                                :needBtn="false"
                                :publicRead="1"
                                :compressImage="true"
                                :compressQuality="0.5"
                                @beforeUpload="beforeUpload"
                                @callback="uploadResponse"
                            >
                            <i class="el-icon-plus notImg"></i>
                            </upload-new-btn>
                        </div>
                    </div>
                </div>
                <div class="receiveRight">
                    <el-row>
                        <el-col :span="8">
                            <div class="colItem">
                                <span class="label">运输单号：</span>
                                <span class="value">{{totalData.taskNo}}</span>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="colItem">
                                <span class="label">发车单号：</span>
                                <span class="value">{{totalData.dispatchNo}}</span>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="colItem">
                                <span class="label">客户订单号：</span>
                                <span class="value"> {{totalData.customerOrderNo}}</span>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="colItem">
                                <span class="label">汇总：</span>
                                <span class="value">实发 {{totalData.realDeliverCountAll}} / 实收 {{receiveNum}} / 异常 {{abnormalNum}}</span>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="colItem">
                                <span class="label">签收人：</span>
                                <span class="value">{{totalData.signContact}}</span>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="colItem">
                                <span class="label">签收时间：</span>
                                <span class="value">{{totalData.signTime}}</span>
                            </div>
                        </el-col>
                        <el-col :span="8" v-if="rowData.projectClassify === 'WP'">
                            <div class="colItem">
                                <span class="label">网批签收完成时间：</span>
                                <span class="value">{{totalData.wpSignTime}}</span>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="colItem">
                                <span class="label">收货人：</span>
                                <span class="value">{{totalData.transReceiverName}}</span>
                            </div>
                        </el-col>
                    </el-row>
                    <el-table :data="tableData" border tooltip-effect="dark" height="260">
                        <el-table-column :show-overflow-tooltip='true' prop="itemCode.value" label="商品编码" align='center'></el-table-column>
                        <el-table-column :show-overflow-tooltip='true' prop="itemName.value" label="商品名称" align='center'></el-table-column>
                        <el-table-column :show-overflow-tooltip='true' prop="financeNo.value" label="财务单号" align='center' v-if='totalData.sourceSystem === "CIMS"'></el-table-column>
                        <el-table-column :show-overflow-tooltip='true' label="正品" width='70' align='center'>
                            <template slot-scope="scope">
                                <div style="position: relative;">
                                    <div style='position: absolute; height: 100%; width: 100%'></div>
                                    <el-tooltip :tabindex="-1" v-model='scope.row.realReceive.showToptip' effect="dark"
                                        content="正品不能为负数 污染-破损-短少-拒收 会影响正品数量,请仔细核对" placement="bottom">
                                        <!-- 下边的margin是为了解决。。两个完全重合的div，会触发下边元素的mouseenter，可能重合有误差，渲染问题 -->
                                        <div :class="{red: scope.row.realReceive.showToptip}" style="margin: 0 5px">{{realReceive(scope.$index)}}</div>
                                    </el-tooltip>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column :show-overflow-tooltip='true' label="污染" width='90' align='center'>
                            <template slot-scope="scope">
                                <div>{{scope.row.mildewPolluteCount.value}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column :show-overflow-tooltip='true' label="破损" width='90' align='center'>
                            <template slot-scope="scope">
                                <div>
                                    <div>{{scope.row.packageDamagedCount.value}}</div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column :show-overflow-tooltip='true' label="短少" width='90' align='center'>
                            <template slot-scope="scope">
                                <div>{{scope.row.stockoutCount.value}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column :show-overflow-tooltip='true' label="拒收" width='90' align='center'>
                            <template slot-scope="scope">
                                <div>{{scope.row.rejectQty.value}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column :show-overflow-tooltip='true' prop="ccsQty.value" label="CCS签收量" v-if="rowData.projectClassify === 'WP'" align='center'></el-table-column>
                        <el-table-column :show-overflow-tooltip='true' prop="compareStatus.value" label="对比状态" v-if="rowData.projectClassify === 'WP'" align='center'></el-table-column>
                        <el-table-column :show-overflow-tooltip='true' label="第三方单号" width='180' align='center'
                        v-if="rowData.projectClassify === 'JD_IN' && rowData.distributionLastFlag === 'Y'">
                        <template slot-scope="scope">
                            <div>{{scope.row.sourceOrderNo.value}}</div>
                        </template>
                        </el-table-column>
                        <el-table-column :show-overflow-tooltip='true' label="备注" width='120' align='center'>
                            <template slot-scope="scope">
                                <div>{{scope.row.signRemark.value}}</div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
        </el-dialog>
</template>
<script>
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';
import common from '@/utils/common';
import { receiptDetail, receiptUpload, receiptDeleteReceiptpicture, receiptSign } from '@/modules/transport/otp/api/receiptSign';
import UploadNewBtn from '@/components/lots/OSS/UploadNewBtn';
import { mapState } from 'vuex';

export default {
    components: { UploadNewBtn },
    props: {
        readOnly: {
            type: Boolean,
            default: false
        },
        signInShow: {
            type: Boolean,
            default() {
                return false;
            }
        },
        rowData: {
            type: Object,
            default() {
                return {};
            }
        },
        query: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            viewer: {},
            closeOnClickModal: false,
            dialogLoading: {}, // 弹框loading实例
            updateTime: '',
            updateUserName: '',
            totalData: {},
            tableData: [],
            imgArr: [],
            carouselIndex: 0 // 轮播图当前的索引
        };
    },
    methods: {
        beforeUpload({ file }) {
            this.$emit('update:loading', true);
            var extArr = ['jpg', 'jpeg', 'png', 'tif', 'bmp'];
            if (!extArr.includes(this.getFileExt(file.name))) {
                this.$message({
                    type: 'warning',
                    message: '文件格式只能为 JPG / JPEG / PNG / TIF / BMP',
                    duration: 5000,
                    showClose: true
                });
                this.$refs.uploadButton.handleUploadStatus(false);
                this.handleDeleteErrorFile(file);
                return false;
            }
        },
        handleDeleteErrorFile (file) { // 清除不符合规格的文件
            this.$refs.uploadButton.$refs.ossElUpload.uploadFiles.forEach((e, i) => {
                if (file.name === e.name) {
                    this.$refs.uploadButton.$refs.ossElUpload.uploadFiles.splice(i, 1);
                }
            });
            this.$refs.uploadButton.uploadDataArr.forEach((e, i) => {
                if (file.name === e.file.name) {
                    this.$refs.uploadButton.uploadDataArr.splice(i, 1);
                }
            });
        },
        getFileExt(fileName) {
            return fileName && fileName.replace(/^.*\./, '').toLowerCase();
        },
        dataURItoBlob(dataURI, type) {
            var binary = atob(dataURI.split(',')[1]);
            var array = [];
            for (var i = 0; i < binary.length; i++) {
                array.push(binary.charCodeAt(i));
            }
            return new Blob([new Uint8Array(array)], { type: type });
        },
        fullLoading(status = true) {
            if (status) {
                this.dialogLoading = this.$loading({
                    target: '.receiptSignSignInDialog > div',
                    background: 'rgba(255, 255, 255, .7)'
                });
            } else {
                this.dialogLoading.close();
            }
        },
        downloadImg() {
            window.location = this.imgArr[this.carouselIndex].path;
        },
        // 删除图片
        deleteImg() {
            const params = {
                taskNo: this.rowData.taskNo,
                filepath: this.imgArr[this.carouselIndex].path
            };
            receiptDeleteReceiptpicture(params).then(res => {
                if (res && +res.code === 0) {
                    this.imgArr.splice(this.carouselIndex, 1);
                    this.$message.success('删除成功');
                    this.updateViewer();
                }
            }).catch(() => {
                this.$message.error('删除失败');
            });
        },
        uploadResponse(response) {
            const params = {
                createUserName: this.user.userName,
                createUserCode: this.user.userCode,
                signFileUpload: 'N',
                taskNoList: [this.rowData.taskNo],
                receiptSource: '10'
            };
            params.fileUrls = response.map(item => item.data.downUrl);
            receiptUpload(params).then(res => {
                if (res) {
                    if (res.data.length > 0) {
                        let message = '';
                        res.data.forEach(item => {
                            message += `<div style='line-height: 30px;'>
                                        <span style='color: #909399;'>图片</span>
                                        <span style='color: #F56C6C;'>${item.pictureName}</span>
                                        <span style='color: #409EFF;'>${item.message}</span>
                                    <div>`;
                        });
                        const duration = 5000 + res.data.length * 1500;
                        this.$message({
                            type: 'warning',
                            duration,
                            dangerouslyUseHTMLString: true,
                            message,
                            showClose: true
                        });
                    } else {
                        this.updateUserName = this.user.userName;
                        this.updateTime = common.formatDateTime(res.timestamp);
                        params.fileUrls.forEach(item => {
                            this.imgArr.unshift({ path: item, updateUserName: this.updateUserName, updateTime: this.updateTime });
                        });
                        this.$message.success('上传成功');
                        this.updateViewer();
                    }
                }
            }).catch(() => {
                this.$message.error('上传失败');
            });
        },
        updateViewer() {
            this.carouselIndex = 0;
            this.viewer.destroy();
            setTimeout(() => {
                this.initViewer();
            });
        },
        roundDecimalPlaces(num) {
            const decimalPlaces = 4;
            const calcFlag = Math.pow(10, decimalPlaces);
            return Math.round(num * calcFlag) / calcFlag;
        },
        initViewer() {
            const barOptions = { show: true, size: 'small' };
            this.viewer = new Viewer(document.getElementById('viewers'), {
                inline: true,
                title: false,
                navbar: true,
                button: true,
                toolbar: {
                    zoomIn: false,
                    zoomOut: false,
                    prev: {
                        show: true,
                        size: 'small',
                        click: () => {
                            if (this.carouselIndex === 0) {
                                this.carouselIndex = this.imgArr.length - 1;
                            } else {
                                this.carouselIndex -= 1;
                            }
                            this.viewer.prev(true);
                        }
                    },
                    reset: false,
                    next: {
                        show: true,
                        size: 'small',
                        click: () => {
                            if (this.carouselIndex === this.imgArr.length - 1) {
                                this.carouselIndex = 0;
                            } else {
                                this.carouselIndex += 1;
                            }
                            this.viewer.next(true);
                        }
                    },
                    rotateLeft: barOptions,
                    rotateRight: barOptions
                }
            });
        },
        getReceiptDetail() {
            // 获取图片
            if (this.rowData.files && this.rowData.files.length) {
                this.rowData.files.forEach(item => {
                    this.imgArr.unshift(item);
                });
            } else {
                this.imgArr = []
            }

            this.$nextTick(() => {
                this.initViewer();
            });

            this.fullLoading();
            this.closeOnClickModal = true;
            receiptDetail(this.rowData.taskNo).then(res => {
                if (res) {
                    res.data.itemDetails.forEach(item => {
                        this.tableData.push({
                            id: item.id,
                            lineNo: item.lineNo,
                            realDeliverCount: item.realDeliverCount,
                            realReceiveCount: item.realReceiveCount,
                            abnormalCount: item.abnormalCount,
                            polluteDamagedCount: item.polluteDamagedCount,
                            quantity: item.quantity,
                            version: item.version,
                            itemStatus: item.itemStatus,
                            itemCode: { show: false, value: item.itemCode }, // 商品编码
                            itemName: { show: false, value: item.itemName }, // 商品名称
                            financeNo: { show: false, value: item.financeNo }, // 财务单号
                            realReceive: { show: false, value: item.realReceive, showToptip: false }, // 正品
                            mildewPolluteCount: { show: false, value: item.mildewPolluteCount }, // 污染
                            packageDamagedCount: { show: false, value: item.packageDamagedCount }, // 破损
                            stockoutCount: { show: false, value: item.stockoutCount }, // 短少
                            rejectQty: { show: false, value: item.rejectQty }, // 拒收
                            ccsQty: { show: false, value: item.ccsQty }, // css签收量
                            compareStatus: { show: false, value: item.compareStatus }, // 对比状态
                            signRemark: { show: false, value: item.signRemark }, // 备注
                            sourceOrderNo: { show: false, value: item.sourceOrderNo } // 第三方单号
                        });
                    });
                    this.totalData = res.data;
                    this.$emit('getTotalData', this.totalData);
                    this.closeOnClickModal = false;
                }
                this.fullLoading(false);
            }).catch(() => {
                this.fullLoading(false);
            });
        },
        beforeClose() {
            this.$emit('handleClose','signInShow');
        }
    },
    mounted () {
        this.getReceiptDetail();
    },
    beforeDestroy() {
        this.viewer.destroy();
    },
    computed: {
        ...mapState({ user: state => state.user }),
        // 正品(单行)
        realReceive(index) {
            return (index) => { // 正品=实发(单行)-污染-破损-短少-拒收
                var item = this.tableData[index];
                const value = item.realDeliverCount - item.mildewPolluteCount.value - item.packageDamagedCount.value - item.stockoutCount.value - item.rejectQty.value;
                item.realReceive.value = this.roundDecimalPlaces(value);
                return item.realReceive.value;
            };
        },
        // 实收(汇总)
        receiveNum() {
            let total = 0;
            this.tableData.forEach(item => { // 实收数量=正品+破损+污染
                var lineTotal = 0;
                lineTotal += Number(item.realReceive.value);
                lineTotal += Number(item.packageDamagedCount.value);
                lineTotal += Number(item.mildewPolluteCount.value);
                item.realReceiveCount = lineTotal; // 单行实收
                total += lineTotal;
            });
            return this.roundDecimalPlaces(total);
        },
        // 异常(汇总)
        abnormalNum() {
            let total = 0;
            this.tableData.forEach(item => { // 异常=拒收+短少+破损+污染
                var lineTotal = 0;
                lineTotal += Number(item.rejectQty.value);
                lineTotal += Number(item.stockoutCount.value);
                lineTotal += Number(item.packageDamagedCount.value);
                lineTotal += Number(item.mildewPolluteCount.value);
                item.abnormalCount = lineTotal; // 单行异常
                total += lineTotal;
            });
            return this.roundDecimalPlaces(total);
        }
    },
};
</script>
<style lang='less'>
@import './signInDialog.less';
</style>
